import styled from 'styled-components';
import { Form } from 'antd';

export const StyledFormItem = styled(Form.Item)`
  margin-bottom: 0px;
`;

export default StyledFormItem;
